<template>
  <a-modal
    v-model:visible="isVisible"
    class="queue-connections-modal connections-modal"
    title="Colas"
    width="500px"
    :maskClosable="false"
    centered
    @cancel="closeModal"
  >
    <a-divider class="divider" />
    <div class="connections-modal__body">
      <h2 class="name">El usuario "{{ userName }}" está asignado a {{ activeQueues.length }} colas:</h2>

      <div class="connections">
        <!-- Contenedor scrollable que construimos antes -->
        <div class="queue-detail-list">
          <div class="queue-detail-list-inner">
            <div
              v-for="(group, campaignName) in groupedQueues"
              :key="campaignName"
              class="connections-group"
            >
              <!-- HEADER -->
              <div class="connections-group__header">
                Campaña "{{ campaignName }}" ({{ group.length }})
              </div>

              <!-- LIST -->
              <div class="connections-list">
                <div
                  v-for="queue in group"
                  :key="queue.id"
                  class="connections-item"
                >
                  <span class="connections-item__name" :title="queue.name">
                    {{ queue.name }}
                  </span>

                  <a-tag color="green">
                    Activo
                  </a-tag>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <template #footer>
      <div class="footer">
        <a-button @click="closeModal">
          Cerrar detalles
        </a-button>
      </div>
    </template>
  </a-modal>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  userName: {
    type: String,
    default: ""
  },
  queues: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(['update:visible']);

const isVisible = computed({
  get: () => props.visible,
  set: (val) => emit('update:visible', val)
});

const closeModal = () => {
  isVisible.value = false;
};

const activeQueues = computed(() => {
  return props.queues?.filter(q => q.status === 1) || [];
});

const groupedQueues = computed(() => {
  if (!activeQueues.value.length) return {};
  
  const groups = {};
  activeQueues.value.forEach(q => {
    const campaign = q.portfolio_name || 'Sin campaña';
    if (!groups[campaign]) {
      groups[campaign] = [];
    }
    groups[campaign].push(q);
  });
  
  return groups;
});
</script>

<style scoped lang="sass">
.name
  font-weight: 600
  font-size: 16px
  color: $gray-9
  margin-bottom: 2px
  margin-top: 10px

.footer
  display: flex
  align-items: center
  justify-content: center
  padding: 13px 20px
  position: absolute
  width: 100%
  bottom: 0
  left: 0
  margin-top: 20px

.divider
  position: absolute
  left: 0
  top: 45px
  margin: 10px 0

.connections-modal
  padding: 4px 0
  &__body
    padding-top: 15px

  .connections
    margin-bottom: 50px

  .connections-group
    margin-top: 15px

    &__header
      font-size: 14px
      font-weight: 600
      color: #262626
      margin-bottom: 8px

  .connections-list
    display: flex
    flex-direction: column

  .connections-item
    display: flex
    align-items: center
    justify-content: space-between
    padding: 10px 12px
    border-bottom: 1px solid #f0f0f0
    transition: background 0.2s ease

    &__name
      flex: 1
      min-width: 0
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
      margin-right: 12px

    &:hover
      background: #fafafa

  /* Lógica de scrollbar conservada del requerimiento anterior */
  .queue-detail-list
    max-height: 400px
    overflow-y: auto
    margin-right: -24px
    
    &::-webkit-scrollbar
      width: 6px
    
    &::-webkit-scrollbar-thumb
      background: #d9d9d9
      border-radius: 4px

  .queue-detail-list-inner
    padding-right: 48px
    display: flex
    flex-direction: column
    gap: 16px

:global(.queue-connections-modal .ant-modal-footer)
  margin-top: 60px !important
</style>
